import $ from 'jquery';

function changeButton(container) {
	container.html('<img src="/assets/images/loading.gif" style="width: 35px;" />');
	container.addClass('text-center');
}

function printInsp(data) {
	const container = $('#inspirationLanding .grid-container');
	container.append(data);
}

function getInsp(url, loader) {
	$.get(url, function(data) {
		printInsp(data);
	})
	.always(function() {
		loader.find('img').remove();
	});
}

function initLoadMore(button, loader) {
	const currentPage = parseInt(button.data('page'));
	const nextPage = currentPage + 1;
	const url = window.location.origin + '/' + 'ajax/inspiration/p' + nextPage;
	changeButton(loader);
	getInsp(url, loader);
}

function attachHandlers() {
	$('#inspirationLanding').on('click', '#loadMoreInsp', function(e) {
		e.preventDefault();
		initLoadMore($(this), $(this).parent());
	});
}

export default attachHandlers;
